// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 353 ? "reactPlayerPreview" : chunkId) + "." + {"353":"880828f1","488":"b52134d1"}[chunkId] + ".chunk.js";
};